import React from "react";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { RANGE_OPTIONS } from "./reportFilters";

export default function ReportsDateFilter({
  rangeMode,
  setRangeMode,
  singleDate,
  setSingleDate,
  dateRange,
  setDateRange,
  loading,
  children,
}) {
  return (
    <div className="card shadow-md p-4 flex flex-wrap items-end gap-3 mb-6">
      <div className="flex flex-col gap-1">
        <label className="text-sm text-gray-500">View</label>
        <Dropdown
          value={rangeMode}
          options={RANGE_OPTIONS}
          optionLabel="name"
          optionValue="value"
          onChange={(e) => setRangeMode(e.value)}
          className="w-48"
        />
      </div>

      {rangeMode === "date" && (
        <div className="flex flex-col gap-1">
          <label className="text-sm text-gray-500">Date</label>
          <Calendar
            value={singleDate}
            onChange={(e) => setSingleDate(e.value)}
            className="w-48"
            dateFormat="dd-M-yy"
          />
        </div>
      )}

      {rangeMode === "custom" && (
        <div className="flex flex-col gap-1">
          <label className="text-sm text-gray-500">Date Range</label>
          <Calendar
            value={dateRange}
            onChange={(e) => setDateRange(e.value)}
            selectionMode="range"
            readOnlyInput
            className="w-64"
            dateFormat="dd-M-yy"
          />
        </div>
      )}

      {children}

      {loading && <span className="text-sm text-gray-400">Loading...</span>}
    </div>
  );
}
